export default __webpack_public_path__ + "images/install1.1dead1e49e9ac28d9e6d59e32b89be58.png";